import React from 'react';
import LawFirmWebsite from './Pages/Page';

const App = () => (
  <div>
    <LawFirmWebsite />
  </div>
);

export default App;

